//# sourceMappingURL=invitation.mjs.map
/// <reference types="./invitation.d.mts" />
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $order from "../../../gleam_stdlib/gleam/order.mjs";
import * as $timestamp from "../../../gleam_time/gleam/time/timestamp.mjs";
import * as $timestamp_ from "../../../tiamat/gleam/time/timestamp_.mjs";
import * as $decrypt from "../../decrypt.mjs";
import { toList, CustomType as $CustomType } from "../../gleam.mjs";

export class Invitation extends $CustomType {
  constructor(id, org_id, invitee_email, inviter_name, invitation_url, created_at, expires_at, connection_id, roles) {
    super();
    this.id = id;
    this.org_id = org_id;
    this.invitee_email = invitee_email;
    this.inviter_name = inviter_name;
    this.invitation_url = invitation_url;
    this.created_at = created_at;
    this.expires_at = expires_at;
    this.connection_id = connection_id;
    this.roles = roles;
  }
}
export const Invitation$Invitation = (id, org_id, invitee_email, inviter_name, invitation_url, created_at, expires_at, connection_id, roles) =>
  new Invitation(id,
  org_id,
  invitee_email,
  inviter_name,
  invitation_url,
  created_at,
  expires_at,
  connection_id,
  roles);
export const Invitation$isInvitation = (value) => value instanceof Invitation;
export const Invitation$Invitation$id = (value) => value.id;
export const Invitation$Invitation$0 = (value) => value.id;
export const Invitation$Invitation$org_id = (value) => value.org_id;
export const Invitation$Invitation$1 = (value) => value.org_id;
export const Invitation$Invitation$invitee_email = (value) =>
  value.invitee_email;
export const Invitation$Invitation$2 = (value) => value.invitee_email;
export const Invitation$Invitation$inviter_name = (value) => value.inviter_name;
export const Invitation$Invitation$3 = (value) => value.inviter_name;
export const Invitation$Invitation$invitation_url = (value) =>
  value.invitation_url;
export const Invitation$Invitation$4 = (value) => value.invitation_url;
export const Invitation$Invitation$created_at = (value) => value.created_at;
export const Invitation$Invitation$5 = (value) => value.created_at;
export const Invitation$Invitation$expires_at = (value) => value.expires_at;
export const Invitation$Invitation$6 = (value) => value.expires_at;
export const Invitation$Invitation$connection_id = (value) =>
  value.connection_id;
export const Invitation$Invitation$7 = (value) => value.connection_id;
export const Invitation$Invitation$roles = (value) => value.roles;
export const Invitation$Invitation$8 = (value) => value.roles;

export class Creation extends $CustomType {
  constructor(org_id, inviter_name, invitee_email, client_id, connection_id, roles) {
    super();
    this.org_id = org_id;
    this.inviter_name = inviter_name;
    this.invitee_email = invitee_email;
    this.client_id = client_id;
    this.connection_id = connection_id;
    this.roles = roles;
  }
}
export const Creation$Creation = (org_id, inviter_name, invitee_email, client_id, connection_id, roles) =>
  new Creation(org_id,
  inviter_name,
  invitee_email,
  client_id,
  connection_id,
  roles);
export const Creation$isCreation = (value) => value instanceof Creation;
export const Creation$Creation$org_id = (value) => value.org_id;
export const Creation$Creation$0 = (value) => value.org_id;
export const Creation$Creation$inviter_name = (value) => value.inviter_name;
export const Creation$Creation$1 = (value) => value.inviter_name;
export const Creation$Creation$invitee_email = (value) => value.invitee_email;
export const Creation$Creation$2 = (value) => value.invitee_email;
export const Creation$Creation$client_id = (value) => value.client_id;
export const Creation$Creation$3 = (value) => value.client_id;
export const Creation$Creation$connection_id = (value) => value.connection_id;
export const Creation$Creation$4 = (value) => value.connection_id;
export const Creation$Creation$roles = (value) => value.roles;
export const Creation$Creation$5 = (value) => value.roles;

export function decoder() {
  return $decode.field(
    "id",
    $decode.string,
    (id) => {
      return $decode.field(
        "org_id",
        $decode.string,
        (org_id) => {
          return $decode.field(
            "invitee",
            $decode.string,
            (invitee_email) => {
              return $decode.field(
                "inviter",
                $decode.string,
                (inviter_name) => {
                  return $decode.field(
                    "invitation_url",
                    $decode.string,
                    (invitation_url) => {
                      return $decode.field(
                        "created_at",
                        $decrypt.timestamp(),
                        (created_at) => {
                          return $decode.field(
                            "expires_at",
                            $decrypt.timestamp(),
                            (expires_at) => {
                              return $decode.field(
                                "connection_id",
                                $decode.string,
                                (connection_id) => {
                                  return $decode.field(
                                    "roles",
                                    $decode.list($decode.string),
                                    (roles) => {
                                      return $decode.success(
                                        new Invitation(
                                          id,
                                          org_id,
                                          invitee_email,
                                          inviter_name,
                                          invitation_url,
                                          created_at,
                                          expires_at,
                                          connection_id,
                                          roles,
                                        ),
                                      );
                                    },
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function encode(invitation) {
  return $json.object(
    toList([
      ["id", $json.string(invitation.id)],
      ["org_id", $json.string(invitation.org_id)],
      ["invitee", $json.string(invitation.invitee_email)],
      ["inviter", $json.string(invitation.inviter_name)],
      ["invitation_url", $json.string(invitation.invitation_url)],
      ["created_at", $timestamp_.encode(invitation.created_at)],
      ["expires_at", $timestamp_.encode(invitation.expires_at)],
      ["connection_id", $json.string(invitation.connection_id)],
      ["roles", $json.array(invitation.roles, $json.string)],
    ]),
  );
}

export function creation_decoder() {
  return $decode.field(
    "org_id",
    $decode.string,
    (org_id) => {
      return $decode.field(
        "inviter",
        $decode.string,
        (inviter_name) => {
          return $decode.field(
            "invitee",
            $decode.string,
            (invitee_email) => {
              return $decode.field(
                "client_id",
                $decode.string,
                (client_id) => {
                  return $decode.field(
                    "connection_id",
                    $decode.string,
                    (connection_id) => {
                      return $decode.field(
                        "roles",
                        $decode.list($decode.string),
                        (roles) => {
                          return $decode.success(
                            new Creation(
                              org_id,
                              inviter_name,
                              invitee_email,
                              client_id,
                              connection_id,
                              roles,
                            ),
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function encode_creation(creation) {
  return $json.object(
    toList([
      ["org_id", $json.string(creation.org_id)],
      ["inviter", $json.string(creation.inviter_name)],
      ["invitee", $json.string(creation.invitee_email)],
      ["client_id", $json.string(creation.client_id)],
      ["connection_id", $json.string(creation.connection_id)],
      ["roles", $json.array(creation.roles, $json.string)],
    ]),
  );
}

export function is_expired(invitation) {
  let $ = $timestamp.compare($timestamp.system_time(), invitation.expires_at);
  if ($ instanceof $order.Lt) {
    return false;
  } else if ($ instanceof $order.Eq) {
    return true;
  } else {
    return true;
  }
}

/**
 * Resending an invitation is creating the same one again: the invitee, the
 * connection and the roles come from the pending invitation, the rest from
 * the context of whoever is resending. The inviter is deliberately the
 * original one, so a resend does not reattribute the invitation.
 */
export function resend(invitation, org_id, client_id) {
  return new Creation(
    org_id,
    invitation.inviter_name,
    invitation.invitee_email,
    client_id,
    invitation.connection_id,
    invitation.roles,
  );
}
